export const TruckParallax = () => {
  return (
    <section
      className="relative h-[300px] md:h-[400px] bg-fixed bg-center bg-cover bg-no-repeat"
      style={{ backgroundColor: '#1A1A1A', backgroundImage: 'linear-gradient(135deg, #5C3A1E 0%, #1A1A1A 50%, #5C3A1E 100%)' }}
    >
      <div className="absolute inset-0 bg-foreground/40" />
      <div className="relative z-10 h-full flex items-center justify-center">
        <div className="text-center px-4">
          <p className="text-secondary text-sm md:text-base font-semibold tracking-widest uppercase mb-3 font-subheading">
            Your Local Contractor
          </p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white">
            SERVING THE NORTH METRO
          </h2>
          <p className="text-white/80 text-base md:text-lg mt-3 max-w-xl mx-auto">
            Roofing, siding, and exterior projects — done right the first time.
          </p>
        </div>
      </div>
    </section>
  );
};
